<template>
  <div class="CenteredModuleBox" :style="containerStyle">
    <div v-for="(module, ind) in filteredModules" @click="navigateToModule(module)" :key="ind" class="module-box" :style="style.gridBox">
      <div class="box icon-title-wrapper" :style="calculateBoxStyle(module)" :class="`${boxClasses} ${config.background ? config.background[themeName] : ''}`">
        <module-icon-with-badge
          v-if="config.badgeOutsideOfBox"
          :unreadCountBadgeColor="badgeColor"
          :isUnreadCountFeatureEnabled="false"
          :iconColor="iconColor"
          :module="module"
          :iconHeight="iconHeight"
          :iconWidth="iconWidth"
          :size="iconSize"
          :invertImgIcons="invertImgIcons"
        ></module-icon-with-badge>

        <module-icon-with-badge
          v-else
          :unreadCountBadgeColor="badgeColor"
          :isUnreadCountFeatureEnabled="mx_isUnreadCountFeatureEnabled(module.type, module.instance)"
          :iconColor="iconColor"
          :module="module"
          :unreadCount="mx_unreadCount(module)"
          :iconHeight="iconHeight"
          :iconWidth="iconWidth"
          :size="iconSize"
          :invertImgIcons="invertImgIcons"
        ></module-icon-with-badge>

        <div
          class="text-subtitle-2 mb-2 px-1 align-center text-center module-title"
          :class="textClasses"
          :style="{ ...textStyle, ...calculateFontStyle(module) }"
        >
          {{ $te(module.title) ? $t(module.title) : module.title }}
        </div>
        <module-box-badge
          v-if="mx_isUnreadCountFeatureEnabled(module.type, module.instance) && config.badgeOutsideOfBox"
          :count="mx_unreadCount(module)"
          :badgeColor="badgeColor"
        ></module-box-badge>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import navigationMixin from '@/mixins/navigationMixin';
import ModuleIconWithBadge from '@/components/icons/ModuleIconWithBadge.vue';
import ModuleBoxBadge from './ModuleBoxBadge.vue';

const widthMap = { xs: '33%', sm: '20%', md: '20%', lg: '14.2%', xl: '10%' };
export default {
  name: 'CenteredModuleBox',
  mixins: [common, configMixin, navigationMixin],
  components: {
    ModuleIconWithBadge,
    ModuleBoxBadge,
  },

  props: {
    config: Object,
  },
  methods: {
    navigateToModule(module) {
      let path = this.buildRoute(module);
      this.$router.push(path);
    },
    calculateBoxStyle(module) {
      let style = {};
      if (this.config.background && this.config.background[this.themeName]) {
        style.background = ' ' + this.config.background[this.themeName];
      }
      if (this.config.backgroundColor && this.config.backgroundColor[this.themeName]) {
        style.background = ' ' + this.config.backgroundColor[this.themeName];
      }

      if (this.config.backgroundShadow && this.config.backgroundShadow[this.themeName]) {
        style.boxShadow = ' ' + this.config.backgroundShadow[this.themeName];
      }

      // overwrite by module setting "useDifferentBg"
      if (module.useDifferentBg === true) {
        style.background = this.config.useDifferentBgColor[this.themeName] + ' !important';
      }

      return { ...style, ...this.boxStyle };
    },
    calculateFontStyle(module) {
      let style = {};
      if (module?.useDifferentFont) {
        style.color = this.config.useDifferentFontColor[this.themeName] + ' !important';
      }
      return style;
    },
  },
  computed: {
    filteredModules() {
      return this.modules.filter((module) => !module.isHiddenInHomeScreenWidgets);
    },
    textStyle() {
      return this.config.textStyle ? this.config.textStyle : {};
    },
    style() {
      if (this.breakpoint.name === 'xs' && this.config.xsPctWidth) {
        return { gridBox: { width: this.config.xsPctWidth } };
      }
      return {
        gridBox: { width: widthMap[this.breakpoint.name] },
      };
    },
    containerStyle() {
      return this.config.containerStyle;
    },
    invertImgIcons() {
      return this.config.invertImgIcons;
    },
    boxStyle() {
      let style = { position: 'relative' };
      if (this.config.style) style = { ...style, ...this.config.style };
      return style;
    },

    iconWidth() {
      return this.config.iconWidth;
    },
    iconHeight() {
      return this.config.iconHeight;
    },
    iconSize() {
      return this.config.iconSize;
    },
    iconColor() {
      return this.config.iconColor[this.themeName];
    },
    badgeColor() {
      return this.config.badgeColor && this.config.badgeColor[this.themeName] ? this.config.badgeColor[this.themeName] : this.theme.unreadBadgeColor;
    },
    boxClasses() {
      let boxClasses = '';

      if (this.config.hasBorder) {
        boxClasses = `module-box-border-${this.darkMode ? 'dark' : 'light'}`;
      }
      if (this.config.background && this.config.background[this.themeName] && this.config.background[this.themeName]) {
        boxClasses += ' ' + this.config.background[this.themeName];
      }
      return boxClasses;
    },
    textClasses() {
      return this.config.fontColor ? `${this.config.fontColor[this.themeName]}--text` : '';
    },
  },
};
</script>

<style scoped>
.CenteredModuleBox {
  display: flex;
  flex-wrap: wrap;
}

.module-box {
  margin: 0 !important;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 2px;
}

.module-title {
  font-size: 0.9em !important;
  white-space: pre-line;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.icon-title-wrapper {
  border-radius: 5px;
}

.box {
  cursor: pointer;
  box-sizing: border-box;
  margin: 1rem auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 140px;
  height: 6rem;
}

.module-box-border-dark {
  box-shadow: 0 0 17px 1px #010101;
  border: 1px solid black !important;
  border-radius: 4px;
}

.module-box-border-light {
  box-shadow: 0 0 17px 1px #cbc6c6;
  border: 1px solid #d5d3d3 !important;
  border-radius: 4px;
}
</style>
